/**
 * Block 12 PR-B Phase B3 Part C Step 21 — SectionConsumables (Е).
 *
 * 5 toggleable fixed rows per методика §1.4.2 «Расходники монтажа»: Клей
 * двухкомпонентный, Жидкие гвозди, Силикон, Растворитель, Стреч-плёнка.
 * Каждый row toggleable + qty + price (manual input).
 *
 * Source: docs/prototypes/screen-2.12.2-kitchen-calc.html lines 502-506.
 *
 * Reference: ADR-0020 §Q1, методика §1.4.2.
 * Hotfix: Bug #1 + Bug #10 (Block 12 audit 2026-05-15) — заменены галлюцинированные
 * позиции (Конфирматы/Шурупы/Минификс/...) на правильные расходники монтажа.
 */

import { SectionCard } from '../components/SectionCard';
import { SectionHeader } from '../components/SectionHeader';
import { ToggleableRow } from './ToggleableRow';

const CONSUMABLE_ROWS = [
  { id: 'glue-2k', label: 'Клей двухкомпонентный', unit: 'шт' },
  { id: 'liquid-nails', label: 'Жидкие гвозди', unit: 'шт' },
  { id: 'silicone', label: 'Силикон', unit: 'шт' },
  { id: 'solvent', label: 'Растворитель', unit: 'шт' },
  { id: 'stretch-film', label: 'Стреч-плёнка', unit: 'шт' },
] as const;

export interface SectionConsumablesProps {
  toggles: Record<string, boolean>;
  quantities: Record<string, number>;
  prices: Record<string, number>;
  onToggle: (id: string, on: boolean) => void;
  onQty: (id: string, qty: number) => void;
  onPrice: (id: string, price: number) => void;
  /** PR-calc-buttons-unify (ADR-0099, ADR-0100) — wires жёлтую кнопку «Найти и узнать цену» → /furniture. */
  onDeeplink?: (rowId: string) => void | Promise<void>;
}

export function SectionConsumables({
  toggles,
  quantities,
  prices,
  onToggle,
  onQty,
  onPrice,
  onDeeplink,
}: SectionConsumablesProps) {
  return (
    <SectionCard testId="section-consumables">
      <SectionHeader>Расходники монтажа</SectionHeader>
      <div className="flex flex-col gap-3">
        {CONSUMABLE_ROWS.map((spec) => {
          const enabled = Boolean(toggles[spec.id]);
          return (
            <ToggleableRow
              key={spec.id}
              id={spec.id}
              label={spec.label}
              unit={spec.unit}
              enabled={enabled}
              qty={quantities[spec.id] ?? 0}
              price={prices[spec.id] ?? 0}
              onToggle={(on) => onToggle(spec.id, on)}
              onQty={(q) => onQty(spec.id, q)}
              onPrice={(p) => onPrice(spec.id, p)}
              deeplink="furniture"
              onDeeplink={onDeeplink ? () => onDeeplink(spec.id) : undefined}
            />
          );
        })}
      </div>
    </SectionCard>
  );
}

export { CONSUMABLE_ROWS };
